var Component = (function ($) {
    /**
     * Generic constructor for all components
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Component(classDef, el, options) {
        // Display error if el is valid HTML Element
        if (!(el instanceof Element)) {
            console.error('!!! ' + el + ' is not an HTML Element');
        }
        // If exists, destroy and reinitialize in child
        var ins = classDef.getInstance(el);
        if (!!ins) {
            ins.destroy();
        }
        this.el = el;
        this.$el = $(el);
        // console.log(this.$el);
    }
    /**
     * Initializes components
     * @param {class} classDef
     * @param {Element | NodeList | jQuery} els
     * @param {Object} options
     */
    Component.init = function (classDef, els, options) {
        var instances = null;
        if (els instanceof Element) {
            instances = new classDef(els, options);
        }
        else if (!!els && (els.jquery || els.cash || els instanceof NodeList)) {
            var instancesArr = [];
            for (var i = 0; i < els.length; i++) {
                instancesArr.push(new classDef(els[i], options));
            }
            instances = instancesArr;
        }
        return instances;
    };
    return Component;
}(jQuery));

var _createClass = function() {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var _get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);
    if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);
        if (parent === null) {
            return undefined;
        } else {
            return get(parent, property, receiver);
        }
    } else if ("value" in desc) {
        return desc.value;
    } else {
        var getter = desc.get;
        if (getter === undefined) {
            return undefined;
        }
        return getter.call(receiver);
    }
};

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

if (typeof JW === 'undefined') var JW = {};
JW.JWGll = (function($) {

    var _pri = {};
    var publ = {};

    _pri.cname       = 'JWGLL';
    _pri.inited      = false;
    _pri.will_reload = false;
    _pri.init_resize = false;
    _pri.$elms       = null;
    _pri.$jwgll      = null;
    _pri.inst        = null;
    _pri.autoplay_id = 0;
    _pri.autoplay_ms = 10000;
    _pri.autoplay    = true;
    _pri.mco_pr      = 0;
    _pri.scaled_down = false;
    _pri.do_blur     = true;

    _pri.opts = {
        dbg_lvl: 1
    };

    _pri.defaults = {
        duration: 200, // ms
        dist: -100, // zoom scale TODO: make this more intuitive as an option
        shift: 0, // spacing for center image
        padding: 0, // Padding between non center items
        numVisible: 5, // Number of visible items in carousel
        fullWidth: false, // Change to full width styles
        indicators: false, // Toggle indicators
        noWrap: false, // Don't wrap around and cycle through items.
        onCycleTo: null // Callback for when a new slide is cycled to.
    };

    _pri.options = {
        duration: 200,
        dist: -88, //-72,
        numVisible: 7,
        shift: 0,
        padding: 0,
        fullWidth: false,
    };

    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    publ.init = function(force)
    {
        _pri.dbgG('*** init()');

        if (typeof force === 'boolean' && force)
        {
            _pri.inited      = false;
            _pri.init_resize = false;
            _pri.will_reload = false;
            _pri.stopAutoplay();
            _pri.inst = null;
        }

        if (_pri.inited)
        {
            return;
        }
        _pri.inited = true;

        _pri.dbg('    lets start ...');

        // _pri.elms = document.querySelectorAll('.jwgll');
        // if (_pri.elms.length != 1)
        // {
        //     _pri.dbg('!!! wrong gll elements count! - exit.');
        //     return;
        // }

        _pri.$jwgll = $('#jwgll');
        if (_pri.$jwgll.length != 1)
        {
            _pri.dbgR('!!! wrong gll wrapper elements count! - exit.');
            return;
        }

        _pri.$elms = $('.jwgll', _pri.$jwgll);
        if (_pri.$elms.length != 1)
        {
            _pri.dbgR('!!! wrong gll elements count! - exit.');
            return;
        }

        _pri.$al       = $('#gll-al');
        _pri.$ar       = $('#gll-ar');
        _pri.$ali      = _pri.$al.find('i');
        _pri.$ari      = _pri.$ar.find('i');
        _pri.$hdl      = $('#gll-hdl');
        _pri.$noul     = $('#gll-hdl').find('ul');

        _pri.page      = JW.Page;

        var sz = _pri.page.getScrollBarSize();
        if (Array.isArray(sz) && sz[0] > 0)
        {
            _pri.mco_pr = sz[0];
            $('#mco').css('padding-right', sz[0] + 'px');
        }

        _pri.do_blur = (!_pri.page.isMobile() && !_pri.page.isIE());

        // _pri.options.onCycleTo = _pri.onCycleTo;

        _pri.page.on('page:resize_done', function(e, o) {
            // _pri.dbg('page:resize_done', o);
            if (!_pri.will_reload && !_pri.init_resize)
            {
                _pri.will_reload = true;
                setTimeout(function() {
                    _pri.will_reload = false;
                    _pri.resize();
                }, 500);
            }
        });

        // _pri.initCarousel(_pri.$elms, _pri.options);
        // _pri.startAutoplay();

        _pri.$al.on('click', function(e) {
            // _pri.dbg('arrow click');
            if (_pri.inst != null)
            {
                _pri.inst.prev();
            }
        });

        _pri.$ar.on('click', function(e) {
            // _pri.dbg('arrow click');
            if (_pri.inst != null)
            {
                _pri.inst.next();
            }
        });

        if (typeof force === 'boolean' && force)
        {
            if (!_pri.will_reload && !_pri.init_resize)
            {
                _pri.will_reload = true;
                setTimeout(function() {
                    _pri.will_reload = false;
                    _pri.resize();
                }, 500);
            }
        }
    };

    // _pri.onCycleTo = function(cur_item, dragged)
    // {
    //     // _pri.dbg('*** onCycleTo()', cur_item, dragged);
    //     _pri.stopAutoplay();
    //     _pri.startAutoplay();
    // };

    _pri.startAutoplay = function()
    {
        if (_pri.autoplay && !_pri.autoplay_id)
        {
            _pri.autoplay_id = setInterval(function() {
                if (_pri.autoplay)
                {
                    _pri.inst.next();
                }
                else
                {
                    _pri.stopAutoplay();
                }
            }, _pri.autoplay_ms);
        }
    };

    _pri.stopAutoplay = function()
    {
        _pri.autoplay = false;
        if (_pri.autoplay_id)
        {
            clearInterval(_pri.autoplay_id);
            // _pri.dbg("stopping autoplay ...");
        }
    };

    _pri.getUpdSliderOpts = function(gw)
    {
        var opts = {
            duration: 200,
            dist: -72,
            numVisible: 7,
            shift: 0,
            padding: 0,
            fullWidth: false,
        };

        if (typeof gw === 'undefined')
        {
            gw = _pri.$jwgll.width();
        }

        if (gw <= 640)
        {
            opts.fullWidth = true;
            opts.numVisible = 1;
        }

        // var flankingItems = 5;
        // var separation = 400;
        // if (gw < 700)
        // {
        //     separation = 400;
        //     flankingItems = 1;
        // }
        // else if (gw < 800)
        // {
        //     separation = 400;
        //     flankingItems = 1;
        // }
        // else if (gw <= 1920 && gw >= 800)
        // {
        //     separation = Math.round(180 + (200 / 1120) * (gw - 800));
        //     flankingItems = Math.round(3 + (2 / 1120) * (gw - 800));
        // }
        //
        // opts.flankingItems = flankingItems;
        // opts.separation = separation;
        //
        // if (gw < _pri.opts.slide_w)
        // {
        //     var h = Math.round((gw * 9 / 16));
        //     opts.slideWidth = gw;
        //     opts.slideHeight = h;
        // }
        // else
        // {
        //     opts.slideWidth = _pri.opts.slide_w;
        //     opts.slideHeight = _pri.opts.slide_h;
        // }
        //
        // var gh = opts.slideHeight + 98; //40 + Math.round(opts.slideHeight / 5);
        // _pri.$jwgll.css('height', gh + 'px');
        //
        // opts.horizon = gh / 2;

        return opts;
    };

    _pri.resize = function()
    {
        // _pri.dbg('*** resize');
        // _pri.init_resize = true;

        var gw    = _pri.$jwgll.width();
        var gh    = _pri.$jwgll.height();
        var $item = _pri.$jwgll.find('.jwgll-item');
        var iw    = $item.width();

        if ($item.length > 0)
        {
            if (gw < 512)
            {
                _pri.scaled_down = true;
                iw = gw;
                $item.css('width', iw + 'px');
                gh = Math.floor(gw * 9 / 16);
                _pri.$elms.css('height', gh + 'px');
                $item.css('height', gh + 'px');

                // var opts = _pri.getUpdSliderOpts(gw);
                // _pri.options = opts;
                _pri.initCarousel(_pri.$elms, _pri.options);
            }
            else
            {
                _pri.$elms.css('height', '288px');

                if (_pri.scaled_down)
                {
                    // _pri.dbg('    init scaled up ...');
                    _pri.scaled_down = false;
                    $item.css('width', '');
                    $item.css('height', '');
                    gh = 288;
                    iw = 512;
                    _pri.initCarousel(_pri.$elms, _pri.options);
                }
            }

            // _pri.dbg('    gw: ', gw);
            // _pri.dbg('    gh: ', gh);
            // _pri.dbg('    iw: ', iw);

            if (gw > 680)
            {
                // _pri.dbg('    big arrows ...');
                if (_pri.$al.hasClass('gll-as-top'))
                {
                    _pri.$al.removeClass('gll-as-top');
                    _pri.$ar.removeClass('gll-as-top');
                }
                // _pri.$ali.css('font-size', '');
                // _pri.$ari.css('font-size', '');
                // _pri.$ali.css('padding', '');
                // _pri.$ari.css('padding', '');
                // _pri.$ali.css('cursor', '');
                // _pri.$ari.css('cursor', '');

                // _pri.$ali.css('padding-left', '');
                // _pri.$ari.css('padding-right', '');

                var aw = (gw - iw) / 2;
                // _pri.dbg('    aw:', aw);

                // _pri.$al.css('width', aw + 'px');
                // _pri.$ar.css('width', aw + 'px');

                // _pri.$ali.css('line-height', (gh) + 'px');
                // _pri.$ari.css('line-height', (gh) + 'px');

                var ah    = _pri.$al.height();
                // _pri.dbg('    gh:', gh);
                // _pri.dbg('    ah:', ah);
                var gha   = _pri.$jwgll.outerHeight(true);
                var vdist = ((gha - ah) / 2);

                _pri.$al.css('top', (vdist) + 'px');
                _pri.$ar.css('top', (vdist) + 'px');

                if (aw > 0)
                {
                    var iw = _pri.$al.width();
                    // _pri.dbg('    iw:', iw);
                    // if ((iw + 30) < aw)
                    // {
                    //     var diff = aw - (iw + 30);
                    //     _pri.$ali.css('padding-left', (diff * 6 / 10) + 'px');
                    //     _pri.$ari.css('padding-right', (diff * 6 / 10) + 'px');
                    // }
                    var dist = Math.ceil((aw - iw) * 4 / 5) - 10;
                    if (dist > 0)
                    {
                        _pri.$al.css('left', dist + 'px');
                        _pri.$ar.css('right', dist + 'px');
                    }
                }
            }
            else
            {
                // _pri.dbg('    small  arrows ...');
                if (!_pri.$al.hasClass('gll-as-top'))
                {
                    _pri.$al.addClass('gll-as-top');
                    _pri.$ar.addClass('gll-as-top');
                }

                // _pri.$al.css('opacity', 0);
                // _pri.$ar.css('opacity', 0);
                // _pri.$ali.css('font-size', '24px');
                // _pri.$ari.css('font-size', '24px');
                // _pri.$ali.css('padding', '5px 10px');
                // _pri.$ari.css('padding', '5px 10px');
                // _pri.$al.css('top', '10px');
                // _pri.$ar.css('top', '10px');
                // _pri.$ali.css('cursor', 'pointer');
                // _pri.$ari.css('cursor', 'pointer');

            }

            if (_pri.inst == null)
            {
                _pri.initCarousel(_pri.$elms, _pri.options);
            }

            _pri.$al.css('opacity', 0.5);
            _pri.$ar.css('opacity', 0.5);
        }
    };

    _pri.initCarousel = function(elms, options)
    {
        _pri.Carousel.init(elms, options);
        _pri.inst = _pri.Carousel.getInstance(elms[0]);
        _pri.startAutoplay();
    }

    _pri.Carousel = function(_Component) {
        _inherits(Carousel, _Component);


        /**
         * Construct Carousel instance
         * @constructor
         * @param {Element} el
         * @param {Object} options
         */
        function Carousel(el, options) {
            _classCallCheck(this, Carousel);

            var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, Carousel, el, options));

            _this.el.JW_Gll = _this;

            /**
             * Options for the carousel
             * @member Carousel#options
             * @prop {Number} duration
             * @prop {Number} dist
             * @prop {Number} shift
             * @prop {Number} padding
             * @prop {Number} numVisible
             * @prop {Boolean} fullWidth
             * @prop {Boolean} indicators
             * @prop {Boolean} noWrap
             * @prop {Function} onCycleTo
             */
            _this.options = $.extend({}, Carousel.defaults, options);

            // Setup
            _this.hasMultipleSlides = _this.$el.find('.jwgll-item').length > 1;
            _this.showIndicators = _this.options.indicators && _this.hasMultipleSlides;
            _this.noWrap = _this.options.noWrap || !_this.hasMultipleSlides;
            _this.pressed = false;
            _this.dragged = false;
            _this.offset = _this.target = 0;
            _this.images = [];
            _this.imgs = [];
            _this.itemWidth = _this.$el.find('.jwgll-item').first().innerWidth();
            _this.itemHeight = _this.$el.find('.jwgll-item').first().innerHeight();
            _this.dim = _this.itemWidth * 2 + _this.options.padding || 1; // Make sure dim is non zero for divisions.
            _this._autoScrollBound = _this._autoScroll.bind(_this);
            _this._trackBound = _this._track.bind(_this);

            // _pri.dbg('hasMultipleSlides', _this.hasMultipleSlides);
            // _pri.dbg('showIndicators', _this.showIndicators);
            // _pri.dbg('noWrap', _this.noWrap);
            // _pri.dbg('itemWidth', _this.itemWidth);
            // _pri.dbg('itemHeight', _this.itemHeight);
            // _pri.dbg('dim', _this.dim);

            // Full Width jwgll setup
            if (_this.options.fullWidth)
            {
                _this.options.dist = 0;
                _this._setCarouselHeight();

                // Offset fixed items when indicators.
                if (_this.showIndicators)
                {
                    _this.$el.find('.jwgll-fixed-item').addClass('with-indicators');
                }
            }

            // Iterate through slides
            _this.$indicators = $('<ul class="indicators"></ul>');
            _this.$el.find('.jwgll-item').each(function(i, el) {
                _this.images.push(el);
                _this.imgs.push($('img', el)[0]);

                if (_this.showIndicators) {
                    var $indicator = $('<li class="indicator-item"></li>');

                    // Add active to first by default.
                    if (i === 0)
                    {
                        $indicator[0].classList.add('active');
                    }

                    _this.$indicators.append($indicator);
                }
            });
            if (_this.showIndicators)
            {
                _this.$el.append(_this.$indicators);
            }
            _this.count = _this.images.length;
            // _pri.dbg('img count', _this.count);

            // Cap numVisible at count
            _this.options.numVisible = Math.min(_this.count, _this.options.numVisible);

            // Setup cross browser string
            _this.xform = 'transform';
            ['webkit', 'Moz', 'O', 'ms'].every(function(prefix) {
                var e = prefix + 'Transform';
                if (typeof document.body.style[e] !== 'undefined')
                {
                    _this.xform = e;
                    return false;
                }
                return true;
            });
            // _pri.dbg('xform', _this.xform);

            _this._setupEventHandlers();
            _this._scroll(_this.offset);
            return _this;
        }

        _createClass(Carousel, [{
            key: 'destroy',


            /**
             * Teardown component
             */
            value: function destroy() {
                this._removeEventHandlers();
                this.el.JW_Gll = undefined;
            }

            /**
             * Setup Event Handlers
             */

        }, {
            key: '_setupEventHandlers',
            value: function _setupEventHandlers() {
                var _this2 = this;

                this._handleCarouselTapBound = this._handleCarouselTap.bind(this);
                this._handleCarouselDragBound = this._handleCarouselDrag.bind(this);
                this._handleCarouselReleaseBound = this._handleCarouselRelease.bind(this);
                this._handleCarouselClickBound = this._handleCarouselClick.bind(this);

                if (typeof window.ontouchstart !== 'undefined')
                {
                    this.el.addEventListener('touchstart', this._handleCarouselTapBound);
                    this.el.addEventListener('touchmove', this._handleCarouselDragBound);
                    this.el.addEventListener('touchend', this._handleCarouselReleaseBound);
                }

                this.el.addEventListener('mousedown', this._handleCarouselTapBound);
                this.el.addEventListener('mousemove', this._handleCarouselDragBound);
                this.el.addEventListener('mouseup', this._handleCarouselReleaseBound);
                this.el.addEventListener('mouseleave', this._handleCarouselReleaseBound);
                this.el.addEventListener('click', this._handleCarouselClickBound);

                if (this.showIndicators && this.$indicators) {
                    this._handleIndicatorClickBound = this._handleIndicatorClick.bind(this);
                    this.$indicators.find('.indicator-item').each(function(i, el) {
                        el.addEventListener('click', _this2._handleIndicatorClickBound);
                    });
                }

                // Resize
                var throttledResize = _pri.throttle(this._handleResize, 200);
                this._handleThrottledResizeBound = throttledResize.bind(this);

                window.addEventListener('resize', this._handleThrottledResizeBound);
            }

            /**
             * Remove Event Handlers
             */

        }, {
            key: '_removeEventHandlers',
            value: function _removeEventHandlers() {
                var _this3 = this;

                if (typeof window.ontouchstart !== 'undefined') {
                    this.el.removeEventListener('touchstart', this._handleCarouselTapBound);
                    this.el.removeEventListener('touchmove', this._handleCarouselDragBound);
                    this.el.removeEventListener('touchend', this._handleCarouselReleaseBound);
                }
                this.el.removeEventListener('mousedown', this._handleCarouselTapBound);
                this.el.removeEventListener('mousemove', this._handleCarouselDragBound);
                this.el.removeEventListener('mouseup', this._handleCarouselReleaseBound);
                this.el.removeEventListener('mouseleave', this._handleCarouselReleaseBound);
                this.el.removeEventListener('click', this._handleCarouselClickBound);

                if (this.showIndicators && this.$indicators) {
                    this.$indicators.find('.indicator-item').each(function(i, el) {
                        el.removeEventListener('click', _this3._handleIndicatorClickBound);
                    });
                }

                window.removeEventListener('resize', this._handleThrottledResizeBound);
            }

            /**
             * Handle Carousel Tap
             * @param {Event} e
             */

        }, {
            key: '_handleCarouselTap',
            value: function _handleCarouselTap(e)
            {
                // _pri.dbg('*** tap() ...');
                _pri.autoplay = false;
                // Fixes firefox draggable image bug
                if (e.type === 'mousedown' && $(e.target).is('img'))
                {
                    e.preventDefault();
                }
                this.pressed = true;
                this.dragged = false;
                this.verticalDragged = false;
                this.reference = this._xpos(e);
                this.referenceY = this._ypos(e);

                this.velocity = this.amplitude = 0;
                this.frame = this.offset;
                this.timestamp = Date.now();
                clearInterval(this.ticker);
                this.ticker = setInterval(this._trackBound, 100);
            }

            /**
             * Handle Carousel Drag
             * @param {Event} e
             */

        }, {
            key: '_handleCarouselDrag',
            value: function _handleCarouselDrag(e) {
                var x = void 0,
                    y = void 0,
                    delta = void 0,
                    deltaY = void 0;
                if (this.pressed) {
                    x = this._xpos(e);
                    y = this._ypos(e);
                    delta = this.reference - x;
                    deltaY = Math.abs(this.referenceY - y);
                    if (deltaY < 30 && !this.verticalDragged) {
                        // If vertical scrolling don't allow dragging.
                        if (delta > 2 || delta < -2) {
                            this.dragged = true;
                            this.reference = x;
                            this._scroll(this.offset + delta);
                        }
                    } else if (this.dragged) {
                        // If dragging don't allow vertical scroll.
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    } else {
                        // Vertical scrolling.
                        this.verticalDragged = true;
                    }
                }

                if (this.dragged) {
                    // If dragging don't allow vertical scroll.
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
            }

            /**
             * Handle Carousel Release
             * @param {Event} e
             */

        }, {
            key: '_handleCarouselRelease',
            value: function _handleCarouselRelease(e)
            {
                // _pri.dbg('*** release ...');
                if (this.pressed)
                {
                    this.pressed = false;
                }
                else
                {
                    return;
                }

                clearInterval(this.ticker);
                this.target = this.offset;
                if (this.velocity > 10 || this.velocity < -10)
                {
                    this.amplitude = 0.9 * this.velocity;
                    this.target = this.offset + this.amplitude;
                }
                this.target = Math.round(this.target / this.dim) * this.dim;

                // No wrap of items.
                if (this.noWrap)
                {
                    if (this.target >= this.dim * (this.count - 1))
                    {
                        this.target = this.dim * (this.count - 1);
                    }
                    else if (this.target < 0)
                    {
                        this.target = 0;
                    }
                }
                this.amplitude = this.target - this.offset;
                this.timestamp = Date.now();
                requestAnimationFrame(this._autoScrollBound);

                if (this.dragged)
                {
                    e.preventDefault();
                    e.stopPropagation();
                }
                return false;
            }

            /**
             * Handle Carousel CLick
             * @param {Event} e
             */

        }, {
            key: '_handleCarouselClick',
            value: function _handleCarouselClick(e)
            {
                // Disable clicks if jwgll was dragged.
                if (this.dragged)
                {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
                else if (!this.options.fullWidth)
                {
                    // _pri.dbg('*** click ... t: ', e.target);
                    var clickedIndex = $(e.target).closest('.jwgll-item').index();
                    // _pri.dbg('    clickedIndex: ', clickedIndex);
                    if (clickedIndex < 0)
                    {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                    var diff = this._wrap(this.center) - clickedIndex;

                    // Disable clicks if jwgll was shifted by click
                    if (diff !== 0) {
                        e.preventDefault();
                        e.stopPropagation();
                    }

                    this._cycleTo(clickedIndex);
                }
            }

            /**
             * Handle Indicator CLick
             * @param {Event} e
             */

        }, {
            key: '_handleIndicatorClick',
            value: function _handleIndicatorClick(e) {
                e.stopPropagation();

                var indicator = $(e.target).closest('.indicator-item');
                if (indicator.length) {
                    this._cycleTo(indicator.index());
                }
            }

            /**
             * Handle Throttle Resize
             * @param {Event} e
             */

        }, {
            key: '_handleResize',
            value: function _handleResize(e)
            {
                if (this.options.fullWidth)
                {
                    this.itemWidth = this.$el.find('.jwgll-item').first().innerWidth();
                    this.imageHeight = this.$el.find('.jwgll-item.active').height();
                    this.dim = this.itemWidth * 2 + this.options.padding;
                    this.offset = this.center * 2 * this.itemWidth;
                    this.target = this.offset;
                    this._setCarouselHeight(true);
                }
                else
                {
                    this._scroll();
                }

                // _pri.dbg('Hmmmmmmmmmmmmmmmmmmmmmmmmmm');
                // setTimeout(function() {
                //     _pri.resize();
                // }, 2000);
            }

            /**
             * Set jwgll height based on first slide
             * @param {Booleam} imageOnly - true for image slides
             */

        }, {
            key: '_setCarouselHeight',
            value: function _setCarouselHeight(imageOnly) {
                var _this4 = this;

                var firstSlide = this.$el.find('.jwgll-item.active').length ? this.$el.find('.jwgll-item.active').first() : this.$el.find('.jwgll-item').first();
                var firstImage = firstSlide.find('img').first();
                if (firstImage.length)
                {
                    if (firstImage[0].complete)
                    {
                        // If image won't trigger the load event
                        var imageHeight = firstImage.height();
                        if (imageHeight > 0)
                        {
                            this.$el.css('height', imageHeight + 'px');
                        }
                        else
                        {
                            // If image still has no height, use the natural dimensions to calculate
                            var naturalWidth = firstImage[0].naturalWidth;
                            var naturalHeight = firstImage[0].naturalHeight;
                            var adjustedHeight = this.$el.width() / naturalWidth * naturalHeight;
                            this.$el.css('height', adjustedHeight + 'px');
                        }
                    }
                    else
                    {
                        // Get height when image is loaded normally
                        firstImage.one('load', function(el, i) {
                            _this4.$el.css('height', el.offsetHeight + 'px');
                        });
                    }
                }
                else if (!imageOnly)
                {
                    var slideHeight = firstSlide.height();
                    this.$el.css('height', slideHeight + 'px');
                }
            }

            /**
             * Get x position from event
             * @param {Event} e
             */

        }, {
            key: '_xpos',
            value: function _xpos(e) {
                // touch event
                if (e.targetTouches && e.targetTouches.length >= 1) {
                    return e.targetTouches[0].clientX;
                }

                // mouse event
                return e.clientX;
            }

            /**
             * Get y position from event
             * @param {Event} e
             */

        }, {
            key: '_ypos',
            value: function _ypos(e) {
                // touch event
                if (e.targetTouches && e.targetTouches.length >= 1) {
                    return e.targetTouches[0].clientY;
                }

                // mouse event
                return e.clientY;
            }

            /**
             * Wrap index
             * @param {Number} x
             */

        }, {
            key: '_wrap',
            value: function _wrap(x) {
                return x >= this.count ? x % this.count : x < 0 ? this._wrap(this.count + x % this.count) : x;
            }

            /**
             * Tracks scrolling information
             */

        }, {
            key: '_track',
            value: function _track() {
                var now = void 0,
                    elapsed = void 0,
                    delta = void 0,
                    v = void 0;

                now = Date.now();
                elapsed = now - this.timestamp;
                this.timestamp = now;
                delta = this.offset - this.frame;
                this.frame = this.offset;

                v = 1000 * delta / (1 + elapsed);
                this.velocity = 0.8 * v + 0.2 * this.velocity;
            }

            /**
             * Auto scrolls to nearest jwgll item.
             */

        }, {
            key: '_autoScroll',
            value: function _autoScroll() {
                var elapsed = void 0,
                    delta = void 0;

                if (this.amplitude)
                {
                    elapsed = Date.now() - this.timestamp;
                    delta = this.amplitude * Math.exp(-elapsed / this.options.duration);
                    if (delta > 2 || delta < -2)
                    {
                        this._scroll(this.target - delta);
                        requestAnimationFrame(this._autoScrollBound);
                    }
                    else
                    {
                        // _pri.dbg('*** last step ...');
                        this._scroll(this.target, true);
                    }
                }
            }

            /**
             * Scroll to target
             * @param {Number} x
             */

        }, {
            key: '_scroll',
            value: function _scroll(x, last_steps) {

                // _pri.dbgG('*** _scroll() x:', x, 'last_steps:', last_steps);

                var _this5 = this;

                // Track scrolling state
                if (!this.$el.hasClass('scrolling'))
                {
                    this.el.classList.add('scrolling');
                }
                if (this.scrollingTimeout != null)
                {
                    window.clearTimeout(this.scrollingTimeout);
                }
                this.scrollingTimeout = window.setTimeout(function() {
                    _this5.$el.removeClass('scrolling');
                }, this.options.duration);

                if (typeof last_steps === 'undefined')
                {
                    last_steps = false;
                }

                // Start actual scroll
                var i = void 0,
                    half = void 0,
                    delta = void 0,
                    dir = void 0,
                    tween = void 0,
                    el = void 0,
                    alignment = void 0,
                    alignmentf = void 0,
                    zTranslation = void 0,
                    tweenedOpacity = void 0,
                    centerTweenedOpacity = void 0;
                var lastCenter = this.center;
                var numVisibleOffset = 1 / this.options.numVisible;
                var dwidth  = void 0;
                var dheight = void 0;

                this.offset = typeof x === 'number' ? x : this.offset;
                this.center = Math.floor((this.offset + this.dim / 2) / this.dim);
                delta = this.offset - this.center * this.dim;
                dir = delta < 0 ? 1 : -1;
                tween = -dir * delta * 2 / this.dim;
                half = this.count >> 1;

                if (this.options.fullWidth)
                {
                    alignment = 'translateX(0)';
                    centerTweenedOpacity = 1;
                }
                else
                {
                    dwidth  = (this.el.clientWidth - this.itemWidth) / 2;
                    dheight = (this.el.clientHeight - this.itemHeight) / 2;
                    alignment = 'translateX(' + dwidth + 'px) ';
                    alignment += 'translateY(' + dheight + 'px)';
                    alignmentf = 'translateX(' + Math.ceil(dwidth) + 'px) ';
                    alignmentf += 'translateY(' + Math.ceil(dheight) + 'px)';

                    centerTweenedOpacity = 1 - numVisibleOffset * tween;
                }

                // if (true || last_steps)
                // {
                //     _pri.dbgG('*** _scroll() x:', x, 'last_steps:', last_steps);
                //     _pri.dbg('    center:', this.center);
                //     _pri.dbg('    delta:', delta);
                //     _pri.dbg('    tween:', tween);
                //     _pri.dbg('    dwidth:', dwidth);
                //     _pri.dbg('    dheight:', dheight);
                //     _pri.dbg('    half:', half);
                // }

                // Set indicator active
                if (this.showIndicators)
                {
                    var diff = this.center % this.count;
                    var activeIndicator = this.$indicators.find('.indicator-item.active');
                    if (activeIndicator.index() !== diff)
                    {
                        activeIndicator.removeClass('active');
                        this.$indicators.find('.indicator-item').eq(diff)[0].classList.add('active');
                    }
                }

                // center
                // Don't show wrapped items.
                var wrp, img;
                // if (!this.noWrap || this.center >= 0 && this.center < this.count)
                // {
                //     wrp = this._wrap(this.center);
                //     el  = this.images[wrp];
                //     img = this.imgs[wrp];
                //
                //     // Add active class to center item.
                //     if (!$(el).hasClass('active'))
                //     {
                //         this.$el.find('.jwgll-item').removeClass('active');
                //         el.classList.add('active');
                //     }
                //     var transformString = alignment + ' translateX(' + -delta / 2 + 'px) translateX(' + dir * this.options.shift * tween * i + 'px) translateZ(' + this.options.dist * tween + 'px)';
                //     this._updateItemStyle(el, img, centerTweenedOpacity, 0, transformString);
                // }

                for (i = 1; i <= half; ++i)
                {
                    // _pri.dbgB('    for i = ' + i);

                    // right side
                    if (this.options.fullWidth)
                    {
                        zTranslation = this.options.dist;
                        tweenedOpacity = i === half && delta < 0 ? 1 - tween : 1;
                    }
                    else
                    {
                        zTranslation = this.options.dist * (i * 2 + tween * dir);
                        tweenedOpacity = 1 - numVisibleOffset * (i * 2 + tween * dir);
                    }
                    // Don't show wrapped items.
                    if (!this.noWrap || this.center + i < this.count)
                    {
                        wrp = this._wrap(this.center + i);
                        el = this.images[wrp];
                        img = this.imgs[wrp];
                        var _transformString = alignment + ' translateX(' + (this.options.shift + (this.dim * i - delta) / 2) + 'px) translateZ(' + zTranslation + 'px)';

                        // _pri.dbg('    wrp:', wrp, 'trans:', _transformString);

                        this._updateItemStyle(el, img, tweenedOpacity, -i, _transformString);
                    }

                    // left side
                    if (this.options.fullWidth)
                    {
                        zTranslation = this.options.dist;
                        tweenedOpacity = i === half && delta > 0 ? 1 - tween : 1;
                    }
                    else
                    {
                        zTranslation = this.options.dist * (i * 2 - tween * dir);
                        tweenedOpacity = 1 - numVisibleOffset * (i * 2 - tween * dir);
                    }
                    // Don't show wrapped items.
                    if (!this.noWrap || this.center - i >= 0)
                    {
                        wrp = this._wrap(this.center - i);
                        el = this.images[wrp];
                        img = this.imgs[wrp];
                        var _transformString2 = alignment + ' translateX(' + (-this.options.shift + (-this.dim * i - delta) / 2) + 'px) translateZ(' + zTranslation + 'px)';

                        // _pri.dbg('    wrp:', wrp, 'trans:', _transformString2);

                        this._updateItemStyle(el, img, tweenedOpacity, -i, _transformString2);
                    }
                }

                // center
                // Don't show wrapped items.
                if (!this.noWrap || this.center >= 0 && this.center < this.count)
                {
                    wrp = this._wrap(this.center);
                    el = this.images[wrp];
                    img = this.imgs[wrp];
                    var _transformString3;

                    if (!last_steps)
                    {
                        _transformString3 = alignment + ' translateX(' + -delta / 2 + 'px) translateX(' + dir * this.options.shift * tween + 'px) translateZ(' + this.options.dist * tween + 'px)';
                    }
                    else
                    {
                        // avoid blur for center image
                        _transformString3 = alignmentf + ' translateX(' + -delta / 2 + 'px) translateX(' + dir * this.options.shift * tween + 'px) translateZ(' + this.options.dist * tween + 'px)';
                    }

                    // _pri.dbg('    wrp:', wrp, 'trans:', _transformString3);

                    this._updateItemStyle(el, img, centerTweenedOpacity, 0, _transformString3);
                }

                // onCycleTo callback
                var $currItem = this.$el.find('.jwgll-item').eq(this._wrap(this.center));
                if (lastCenter !== this.center && typeof this.options.onCycleTo === 'function')
                {
                    // _pri.dbgY('>>> call onCycleTo()');
                    this.options.onCycleTo.call(this, $currItem[0], this.dragged);
                }

                // One time callback
                if (typeof this.oneTimeCallback === 'function')
                {
                    // _pri.dbgY('>>> call oneTimeCallback()');
                    this.oneTimeCallback.call(this, $currItem[0], this.dragged);
                    this.oneTimeCallback = null;
                }
            }

            /**
             * Cycle to target
             * @param {Element} el
             * @param {Number} opacity
             * @param {Number} zIndex
             * @param {String} transform
             */

        }, {
            key: '_updateItemStyle',
            value: function _updateItemStyle(el, img, opacity, zIndex, transform) {
                // console.log('opacity:', opacity, zIndex);
                // console.log($(el));
                if (opacity < 0)
                {
                    opacity = 0;
                }

                // should be mobile / phone dependent
                if (_pri.do_blur)
                {
                    var b = ((1 - opacity) * 20) | 0;
                    if (b == 0)
                    {
                        img.style.filter = '';
                    }
                    else
                    {
                        img.style.filter = 'blur(' + b + 'px)';
                    }
                }
                else
                {
                    opacity *= opacity;
                }

                // console.log(b);
                el.style[this.xform] = transform;
                el.style.zIndex = zIndex;
                el.style.opacity = opacity;
                el.style.visibility = 'visible';

                // _pri.dbg('style:', this.xform);

                // if (opacity > 0.9)
                // {
                //     img.style.filter = '';
                // }
                // else if (opacity > 0.8)
                // {
                //     img.style.filter = 'blur(1px)';
                // }
                // else if (opacity > 0.7)
                // {
                //     img.style.filter = 'blur(2px)';
                // }
                // else if (opacity > 0.6)
                // {
                //     img.style.filter = 'blur(3px)';
                // }
                // else if (opacity > 0.5)
                // {
                //     img.style.filter = 'blur(5px)';
                // }
                // else if (opacity > 0.4)
                // {
                //     img.style.filter = 'blur(6px)';
                // }
                // else
                // {
                //     img.style.filter = 'blur(8px)';
                // }

            }

            /**
             * Cycle to target
             * @param {Number} n
             * @param {Function} callback
             */

        }, {
            key: '_cycleTo',
            value: function _cycleTo(n, callback) {
                var diff = this.center % this.count - n;

                // Account for wraparound.
                if (!this.noWrap) {
                    if (diff < 0) {
                        if (Math.abs(diff + this.count) < Math.abs(diff)) {
                            diff += this.count;
                        }
                    } else if (diff > 0) {
                        if (Math.abs(diff - this.count) < diff) {
                            diff -= this.count;
                        }
                    }
                }

                this.target = this.dim * Math.round(this.offset / this.dim);
                // Next
                if (diff < 0) {
                    this.target += this.dim * Math.abs(diff);

                    // Prev
                } else if (diff > 0) {
                    this.target -= this.dim * diff;
                }

                // Set one time callback
                if (typeof callback === 'function') {
                    this.oneTimeCallback = callback;
                }

                // Scroll
                if (this.offset !== this.target) {
                    this.amplitude = this.target - this.offset;
                    this.timestamp = Date.now();
                    requestAnimationFrame(this._autoScrollBound);
                }
            }

            /**
             * Cycle to next item
             * @param {Number} [n]
             */

        }, {
            key: 'next',
            value: function next(n) {
                if (n === undefined || isNaN(n)) {
                    n = 1;
                }

                var index = this.center + n;
                if (index >= this.count || index < 0) {
                    if (this.noWrap) {
                        return;
                    }

                    index = this._wrap(index);
                }
                this._cycleTo(index);
            }

            /**
             * Cycle to previous item
             * @param {Number} [n]
             */

        }, {
            key: 'prev',
            value: function prev(n) {
                if (n === undefined || isNaN(n)) {
                    n = 1;
                }

                var index = this.center - n;
                if (index >= this.count || index < 0) {
                    if (this.noWrap) {
                        return;
                    }

                    index = this._wrap(index);
                }

                this._cycleTo(index);
            }

            /**
             * Cycle to nth item
             * @param {Number} [n]
             * @param {Function} callback
             */

        }, {
            key: 'set',
            value: function set(n, callback) {
                if (n === undefined || isNaN(n)) {
                    n = 0;
                }

                if (n > this.count || n < 0) {
                    if (this.noWrap) {
                        return;
                    }

                    n = this._wrap(n);
                }

                this._cycleTo(n, callback);
            }
        }], [{
            key: 'init',
            value: function init(els, options) {
                return _get(Carousel.__proto__ || Object.getPrototypeOf(Carousel), 'init', this).call(this, this, els, options);
            }

            /**
             * Get Instance
             */

        }, {
            key: 'getInstance',
            value: function getInstance(el) {
                var domElem = !!el.jquery ? el[0] : el;
                return domElem.JW_Gll;
            }
        }, {
            key: 'defaults',
            get: function get() {
                return _pri.defaults;
            }
        }]);

        return Carousel;
    }(Component);

    _pri.extend();

    return publ;

})(jQuery);